export class Deferrable<T> {
	#promise: Promise<T>;
	#resolve!: (value: T) => void;
	#reject!: (reason: any) => void;

	constructor() {
		this.#promise = new Promise<T>((resolve, reject) => {
			this.#resolve = resolve;
			this.#reject = reject;
		});

		this.resolve = this.resolve.bind(this);
		this.reject = this.reject.bind(this);
	}

	resolve(value: T): void {
		this.#resolve(value);
	}

	reject(reason: any): void {
		this.#reject(reason);
	}

	get(): Promise<T> {
		return this.#promise;
	}
}
